import { gql, TypedDocumentNode } from '@apollo/client';

import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

type AvalibleMerchants = {
  bog?: boolean;
  flitt?: boolean;
};
export type CanAddNewCardResponse = {
  canAddNewCard: DefaultApiResponse<AvalibleMerchants>;
};
export const canAddNewCardQuery: TypedDocumentNode<
  CanAddNewCardResponse,
  DefaultArg
> = gql`
  query CanAddNewCard {
    canAddNewCard {
      bog
      flitt
    }
  }
`;
